/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Merge_GroupsInputs */



/**
* | output |
* | --- |
* | "Merge Groups" |
*
* @param {Event_Group_Options_Merge_GroupsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_merge_groups = /** @type {((inputs?: Event_Group_Options_Merge_GroupsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Merge_GroupsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fusionner les groupes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppen zusammenführen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unisci gruppi")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Объединение групп")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fusionar grupos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("合并群组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループの結合")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूहों को मर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unir grupos")
	return /** @type {LocalizedString} */ ("Merge Groups")
});